import React, { useState } from "react";
import digitalmarketing from "../../../../images/LandingPageImage/digital.png";
import support from "../../../../images/LandingPageImage/support.png";
import sales from "../../../../images/LandingPageImage/sales.png";
import Ornament from "../../../../images/LandingPageImage/Ornament.svg"

const contentItems = [
    {
        title: "Marketing",
        desc1: "Get to the desirable customers at the appropriate time.",
        desc2: "Smarter WhatsApp campaigns make things visible, engage and convert attention to action without wasting time or effort.",
        img: digitalmarketing,
    },
    {
        title: "Support",
        desc1: "Find solutions to questions more quickly through intelligent automation.",
        desc2: "Automate replies, handle discussions easily and offer regular support that keeps the customers informed and happy.",
        img: support,
    },
    {
        title: "Sales",
        desc1: "Turn emails on you to communicate instantly and reliably.",
        desc2: "Act in real-time, automatically follow up and provide a seamless purchasing experience that results in trust and faster dealings.",
        img: sales,
    },
];

export default function AchivementResponsive() {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [currentImageSrc, setCurrentImageSrc] = useState(contentItems[0].img);
    const [fade, setFade] = useState(false);

    const handleClick = (img, index) => {
        setSelectedIndex(index);
        setFade(true);
        setTimeout(() => {
            setCurrentImageSrc(img);
            setFade(false);
        }, 200);
    };

    return (
        <section className="py-5 py-md-6 px-3 font-inter" style={{ background: "linear-gradient(45deg, #02151B, #088757)" }}>

            
            <header className="text-center mx-auto" style={{ maxWidth: "768px" }}>
                <h2 className="fw-semibold" style={{ fontFamily: "Bricolage Grotesque, sans-serif", fontSize: "2rem", lineHeight: "1.2", color: "#ffffff" }}>
                    Grow your business using a sophisticated WhatsApp business solution<br className="d-none d-sm-block" />
                    Higher Conversions
                </h2>
                <p className="mt-2 text-white" style={{ fontSize: "1rem", fontWeight: 300 }}>
                    Find More Customers, Reply In Real Time, Convert Smarter
                </p>
            </header>

           
            <div className="mt-4 mt-lg-5 row g-4 justify-content-center align-items-center" style={{ maxWidth: "900px", margin: "0 auto" }}>

                
                <div className="col-12 col-lg-6 d-flex flex-column gap-3">
                    {contentItems.map((item, index) => (
                        <div
                            key={index}
                            onMouseEnter={() => handleClick(item.img, index)}
                            className={`p-3 rounded-3 d-flex flex-column flex-sm-row align-items-start gap-3 cursor-pointer transition`}
                            style={{
                                background: selectedIndex === index ? "linear-gradient(to left, #227D5300, #227D53dd)" : "transparent",
                                transition: "all 0.3s"
                            }}
                        >
                            
                           

                            
                            <div>
                                <div className="mb-3">
                                    <div className="d-inline-block border rounded-pill px-3 py-1" style={{ borderColor: "#F6FAF9", backgroundColor: "rgba(255,255,255,0.1)" }}>
                                        <p className="mb-0 fw-medium text-white" style={{ fontSize: "1rem" }}>{item.title}</p>
                                    </div>
                                </div>
                                <p className="fw-semibold mb-1" style={{
                                    fontFamily: "Bricolage Grotesque, sans-serif",
                                    fontSize: "1.25rem",
                                    color: selectedIndex === index ? "#C7EB4F" : "rgba(255,255,255,0.5)",
                                    lineHeight: "1.3"
                                }}>
                                    {item.desc1}
                                </p>
                                <p className="mb-0" style={{
                                    fontSize: "0.875rem",
                                    lineHeight: "1.5",
                                    color: selectedIndex === index ? "#E5E5E5" : "rgba(229,229,229,0.5)"
                                }}>
                                    {item.desc2}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

               
                <div className="col-12 col-lg-6 position-relative d-flex align-items-center justify-content-center overflow-hidden">
                    <img src={Ornament} className="img-fluid w-100 h-100" style={{ objectFit: "cover" }} />
                    <img
                        src={currentImageSrc}
                        alt="feature"
                        className="position-absolute w-100 h-100 transition"
                        style={{
                            objectFit: "contain",
                            opacity: fade ? 0.6 : 1,
                            transform: fade ? "scale(0.97)" : "scale(1)",
                            transition: "all 0.1s"
                        }}
                    />
                </div>

            </div>
        </section>

    );
}
